import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-278e4372"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-layout" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "container-fluid" }
const _hoisted_4 = { class: "card card-flex card-outline card-themes" }
const _hoisted_5 = { class: "card-header" }
const _hoisted_6 = { class: "btn-group" }
const _hoisted_7 = { class: "card-tools" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("全局搜索")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("取消搜索")
const _hoisted_10 = {
  key: 0,
  class: "dropdown-divider"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dropdown-divider" }, null, -1))
const _hoisted_13 = /*#__PURE__*/_createTextVNode("搜索名称")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("搜索说明")
const _hoisted_15 = { class: "btn-group float-right mr-2 hidden-xs" }
const _hoisted_16 = { class: "card-body table-responsive p-0" }
const _hoisted_17 = {
  key: 0,
  class: "table table-striped table-head-fixed table-width-auto text-nowrap text-center"
}
const _hoisted_18 = { ref: "tableTr" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "id" }, "ID", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "操作", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "projectStatus" }, "状态", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "orgTypeName" }, "组织类型", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "serialNumber" }, "出厂序列号", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "cockpitCode" }, "驾驶舱编号", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "projectCode" }, "设备编码", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "assetCode" }, "资产编码", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "projectName" }, "设备名称", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "orgAddress" }, "设备地址", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "projectSourceIdName" }, "设备来源", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "projectWarrantyName" }, "是否在保", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "acceptanceTime" }, "验收时间", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "hardwareExpireTime" }, "硬件过保", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "serviceExpireTime" }, "服务过保", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  field: "projectRemark",
  class: "normal-width text-left"
}, "设备说明", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "createName" }, "创建姓名", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "createTime" }, "创建时间", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "modifyName" }, "修改姓名", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "modifyTime" }, "修改时间", -1))
const _hoisted_39 = { key: 0 }
const _hoisted_40 = ["colspan"]
const _hoisted_41 = /*#__PURE__*/_createTextVNode("暂无数据")
const _hoisted_42 = { class: "table-btn-group" }
const _hoisted_43 = { class: "btn-group" }
const _hoisted_44 = ["onClick"]
const _hoisted_45 = ["onClick"]
const _hoisted_46 = ["onClick"]
const _hoisted_47 = ["onClick"]
const _hoisted_48 = { key: 2 }
const _hoisted_49 = ["onClick"]
const _hoisted_50 = { class: "text-left" }
const _hoisted_51 = {
  key: 0,
  class: "overlay hyper-text-themes animate__animated animate__fadeIn"
}
const _hoisted_52 = { class: "content-modal" }
const _hoisted_53 = { class: "qr-container" }
const _hoisted_54 = { class: "row" }
const _hoisted_55 = { class: "form-group col-lg-4" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "select-label" }, "验收时间", -1))

export function render(_ctx, _cache) {
  const _component_app_content_header = _resolveComponent("app-content-header")
  const _component_svg_icon = _resolveComponent("svg-icon")
  const _component_app_dropdown_search = _resolveComponent("app-dropdown-search")
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_app_table_page = _resolveComponent("app-table-page")
  const _component_app_alert = _resolveComponent("app-alert")
  const _component_qrcode_vue = _resolveComponent("qrcode-vue")
  const _component_app_modal = _resolveComponent("app-modal")
  const _component_app_select_level = _resolveComponent("app-select-level")
  const _component_app_select_from_db = _resolveComponent("app-select-from-db")
  const _component_app_select_from_dictionary = _resolveComponent("app-select-from-dictionary")
  const _component_app_input = _resolveComponent("app-input")
  const _component_app_switch_number = _resolveComponent("app-switch-number")
  const _component_app_textarea = _resolveComponent("app-textarea")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_app_content_header),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (_ctx.Auth('/project/project/list/add'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-themes",
                    onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.addModalOpen && _ctx.addModalOpen(...args)))
                  }, [
                    _createVNode(_component_svg_icon, { name: "add" })
                  ]))
                : _createCommentVNode("", true),
              (_ctx.Auth('/project/project/list/levelSelect'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    type: "button",
                    class: "btn btn-themes",
                    onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.orgCodeLevelModalOpen && _ctx.orgCodeLevelModalOpen(...args)))
                  }, [
                    _createVNode(_component_svg_icon, { name: "list-outline" })
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_7, [
              (_ctx.Auth('/project/project/list/list'))
                ? (_openBlock(), _createBlock(_component_app_dropdown_search, {
                    key: 0,
                    ref: "tableSearch",
                    modelValue: _ctx.tableRequestItem.searchKey,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((_ctx.tableRequestItem.searchKey) = $event)),
                    searchFunction: _ctx.searchFunction,
                    disabledTableExport: !_ctx.Auth('/project/project/list/export')
                  }, {
                    "dropdown-search-menu": _withCtx(() => [
                      _createElementVNode("li", {
                        class: "dropdown-item hyper-text-themes hand",
                        onClick: _cache[2] || (_cache[2] = $event => (_ctx.searchFunction('all')))
                      }, [
                        _createVNode(_component_svg_icon, {
                          name: "pricetags-sharp",
                          class: "mt-0 mr-2"
                        }),
                        _hoisted_8
                      ]),
                      _createElementVNode("li", {
                        class: "dropdown-item hand",
                        onClick: _cache[3] || (_cache[3] = $event => (_ctx.searchCancel()))
                      }, [
                        _createVNode(_component_svg_icon, {
                          name: "pricetags-outline",
                          class: "mt-0 mr-2"
                        }),
                        _hoisted_9
                      ]),
                      (_ctx.tableRequestItem.lockItem)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.tableRequestItem.lockItem, (item, key, i) => {
                            return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                              (i===0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_10))
                                : _createCommentVNode("", true),
                              _createElementVNode("li", {
                                class: _normalizeClass([item.value?'hyper-text-themes':'', "dropdown-item hand"]),
                                onClick: $event => (item.code?item.openFn(key):item.openFn())
                              }, [
                                _createVNode(_component_svg_icon, {
                                  name: item.value?'radio-button-on':'radio-button-off',
                                  class: "mt-0 mr-1"
                                }, null, 8, ["name"]),
                                _createTextVNode(" " + _toDisplayString(item.title), 1)
                              ], 10, _hoisted_11)
                            ], 64))
                          }), 128))
                        : _createCommentVNode("", true),
                      _hoisted_12,
                      _createElementVNode("li", {
                        class: "dropdown-item hand",
                        onClick: _cache[4] || (_cache[4] = $event => (_ctx.searchFunction('project_name')))
                      }, [
                        _createVNode(_component_svg_icon, {
                          name: "pricetag-outline",
                          class: "mt-0 mr-2"
                        }),
                        _hoisted_13
                      ]),
                      _createElementVNode("li", {
                        class: "dropdown-item hand",
                        onClick: _cache[5] || (_cache[5] = $event => (_ctx.searchFunction('project_remark')))
                      }, [
                        _createVNode(_component_svg_icon, {
                          name: "pricetag-outline",
                          class: "mt-0 mr-2"
                        }),
                        _hoisted_14
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "searchFunction", "disabledTableExport"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_el_date_picker, {
                modelValue: _ctx.tableRequestItem.dateTime,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => ((_ctx.tableRequestItem.dateTime) = $event)),
                type: "datetimerange",
                shortcuts: _ctx.dateTimeShortcuts,
                size: "large",
                "range-separator": "至",
                "start-placeholder": "开始时间",
                "end-placeholder": "结束时间",
                "value-format": "YYYY-MM-DD HH:mm:ss",
                style: {"height":"calc(2.25rem + 2px)"},
                onChange: _cache[8] || (_cache[8] = $event => (_ctx.searchFunction('search')))
              }, null, 8, ["modelValue", "shortcuts"])
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            (_ctx.Auth('/project/project/list/list'))
              ? (_openBlock(), _createElementBlock("table", _hoisted_17, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", _hoisted_18, [
                      _hoisted_19,
                      _hoisted_20,
                      _hoisted_21,
                      _hoisted_22,
                      _createElementVNode("th", {
                        field: "projectYeahIdName",
                        class: "table-search-lock hand active",
                        onClick: _cache[9] || (_cache[9] = $event => (_ctx.dictionaryModalOpen('projectYeahId')))
                      }, "设备年份"),
                      _createElementVNode("th", {
                        field: "orgCode",
                        class: "table-search-lock hand active",
                        onClick: _cache[10] || (_cache[10] = (...args) => (_ctx.orgCodeLevelModalOpen && _ctx.orgCodeLevelModalOpen(...args)))
                      }, "组织代码"),
                      _createElementVNode("th", {
                        field: "orgCodeName",
                        class: "table-search-lock hand active",
                        onClick: _cache[11] || (_cache[11] = (...args) => (_ctx.orgCodeLevelModalOpen && _ctx.orgCodeLevelModalOpen(...args)))
                      }, "所属组织"),
                      _createElementVNode("th", {
                        field: "projectOptModeIdName",
                        class: "table-search-lock hand active",
                        onClick: _cache[12] || (_cache[12] = $event => (_ctx.dictionaryModalOpen('projectOptModeId')))
                      }, "运营模式"),
                      _createElementVNode("th", {
                        field: "projectLayerIdName",
                        class: "table-search-lock hand active",
                        onClick: _cache[13] || (_cache[13] = $event => (_ctx.dictionaryModalOpen('projectLayerId')))
                      }, "设备层数"),
                      _createElementVNode("th", {
                        field: "projectCraftsIdName",
                        class: "table-search-lock hand active",
                        onClick: _cache[14] || (_cache[14] = (...args) => (_ctx.projectCraftsIdLevelModalOpen && _ctx.projectCraftsIdLevelModalOpen(...args)))
                      }, "设备工艺"),
                      _createElementVNode("th", {
                        field: "projectTypeIdName",
                        class: "table-search-lock hand active",
                        onClick: _cache[15] || (_cache[15] = (...args) => (_ctx.projectTypeIdLevelModalOpen && _ctx.projectTypeIdLevelModalOpen(...args)))
                      }, "设备类型"),
                      _hoisted_23,
                      _hoisted_24,
                      _hoisted_25,
                      _hoisted_26,
                      _hoisted_27,
                      _hoisted_28,
                      _hoisted_29,
                      _hoisted_30,
                      _hoisted_31,
                      _hoisted_32,
                      _hoisted_33,
                      _hoisted_34,
                      _createElementVNode("th", {
                        field: "projectMachineIdName",
                        class: "table-search-lock hand active",
                        onClick: _cache[16] || (_cache[16] = $event => (_ctx.dictionaryModalOpen('projectMachineId')))
                      }, "机械"),
                      _createElementVNode("th", {
                        field: "projectInformationIdName",
                        class: "table-search-lock hand active",
                        onClick: _cache[17] || (_cache[17] = $event => (_ctx.dictionaryModalOpen('projectInformationId')))
                      }, "信息"),
                      _createElementVNode("th", {
                        field: "projectIntegrationIdName",
                        class: "table-search-lock hand active",
                        onClick: _cache[18] || (_cache[18] = $event => (_ctx.dictionaryModalOpen('projectIntegrationId')))
                      }, "集成"),
                      _hoisted_35,
                      _hoisted_36,
                      _hoisted_37,
                      _hoisted_38
                    ], 512)
                  ]),
                  _createElementVNode("tbody", null, [
                    (_ctx.tableItems.length<1)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_39, [
                          _createElementVNode("td", {
                            colspan: _ctx.getTableTrLength(_ctx.$refs.tableTr)
                          }, [
                            _createVNode(_component_svg_icon, { name: "alert" }),
                            _hoisted_41
                          ], 8, _hoisted_40)
                        ]))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableItems, (item, i) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: item.projectId,
                        class: _normalizeClass({'text-red': parseInt(item.projectStatus)===2})
                      }, [
                        _createElementVNode("td", null, _toDisplayString(((_ctx.tablePageItems.current-1) * _ctx.tablePageItems.size) + i + 1), 1),
                        _createElementVNode("td", _hoisted_42, [
                          _createElementVNode("div", _hoisted_43, [
                            (_ctx.Auth('/project/project/list/mod'))
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  type: "button",
                                  class: "btn btn-themes",
                                  onClick: $event => (_ctx.modModalOpen(item))
                                }, [
                                  _createVNode(_component_svg_icon, { name: "settings-outline" })
                                ], 8, _hoisted_44))
                              : _createCommentVNode("", true),
                            (_ctx.Auth('/project/project/list/del'))
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 1,
                                  type: "button",
                                  class: "btn btn-themes",
                                  onClick: $event => (_ctx.delAlert(item))
                                }, [
                                  _createVNode(_component_svg_icon, { name: "trash-outline" })
                                ], 8, _hoisted_45))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        (parseInt(item.projectStatus)===1)
                          ? (_openBlock(), _createElementBlock("td", {
                              key: 0,
                              class: "hand",
                              onClick: $event => (_ctx.toggleStatus(item))
                            }, [
                              _createVNode(_component_svg_icon, {
                                name: "checkmark-circle-outline",
                                class: "hyper-text-themes"
                              })
                            ], 8, _hoisted_46))
                          : (parseInt(item.projectStatus)===2)
                            ? (_openBlock(), _createElementBlock("td", {
                                key: 1,
                                class: "hand",
                                onClick: $event => (_ctx.toggleStatus(item))
                              }, [
                                _createVNode(_component_svg_icon, {
                                  name: "close-circle-outline",
                                  class: "text-red"
                                })
                              ], 8, _hoisted_47))
                            : (_openBlock(), _createElementBlock("td", _hoisted_48, "未知")),
                        _createElementVNode("td", null, _toDisplayString(item.orgTypeName), 1),
                        _createElementVNode("td", {
                          class: _normalizeClass(["table-search-lock", _ctx.tableRequestItem.lockItem.projectYeahId.value? 'active' : ''])
                        }, _toDisplayString(item.projectYeahIdName), 3),
                        _createElementVNode("td", {
                          class: _normalizeClass(["table-search-lock", _ctx.tableRequestItem.lockItem.orgCode.value? 'active' : ''])
                        }, _toDisplayString(item.orgCode), 3),
                        _createElementVNode("td", {
                          class: _normalizeClass(["table-search-lock", _ctx.tableRequestItem.lockItem.orgCode.value? 'active' : ''])
                        }, _toDisplayString(item.orgCodeName), 3),
                        _createElementVNode("td", {
                          class: _normalizeClass(["table-search-lock", _ctx.tableRequestItem.lockItem.projectOptModeId.value? 'active' : ''])
                        }, _toDisplayString(item.projectOptModeIdName), 3),
                        _createElementVNode("td", {
                          class: _normalizeClass(["table-search-lock", _ctx.tableRequestItem.lockItem.projectLayerId.value? 'active' : ''])
                        }, _toDisplayString(item.projectLayerIdName), 3),
                        _createElementVNode("td", {
                          class: _normalizeClass(["table-search-lock", _ctx.tableRequestItem.lockItem.projectCraftsId.value? 'active' : ''])
                        }, _toDisplayString(item.projectCraftsIdName), 3),
                        _createElementVNode("td", {
                          class: _normalizeClass(["table-search-lock", _ctx.tableRequestItem.lockItem.projectTypeId.value? 'active' : ''])
                        }, _toDisplayString(item.projectTypeIdName), 3),
                        _createElementVNode("td", {
                          onClick: $event => (_ctx.qrcodeModalOpen(item.projectName, item.serialNumber)),
                          tabindex: "0",
                          class: _normalizeClass([{active: this.qrcodeSerialNumber === item.serialNumber}, "serial-td"])
                        }, _toDisplayString(item.serialNumber), 11, _hoisted_49),
                        _createElementVNode("td", null, _toDisplayString(item.cockpitCode), 1),
                        _createElementVNode("td", null, _toDisplayString(item.projectCode), 1),
                        _createElementVNode("td", null, _toDisplayString(item.assetCode), 1),
                        _createElementVNode("td", null, _toDisplayString(item.projectName), 1),
                        _createElementVNode("td", null, _toDisplayString(item.orgAddress), 1),
                        _createElementVNode("td", null, _toDisplayString(item.projectSourceIdName), 1),
                        _createElementVNode("td", null, _toDisplayString(item.projectWarrantyName), 1),
                        _createElementVNode("td", null, _toDisplayString(item.acceptanceTime), 1),
                        _createElementVNode("td", null, _toDisplayString(item.hardwareExpireTime), 1),
                        _createElementVNode("td", null, _toDisplayString(item.serviceExpireTime), 1),
                        _createElementVNode("td", _hoisted_50, _toDisplayString(item.projectRemark), 1),
                        _createElementVNode("td", {
                          class: _normalizeClass(["table-search-lock", _ctx.tableRequestItem.lockItem.projectMachineId.value? 'active' : ''])
                        }, _toDisplayString(item.projectMachineIdName), 3),
                        _createElementVNode("td", {
                          class: _normalizeClass(["table-search-lock", _ctx.tableRequestItem.lockItem.projectInformationId.value? 'active' : ''])
                        }, _toDisplayString(item.projectInformationIdName), 3),
                        _createElementVNode("td", {
                          class: _normalizeClass(["table-search-lock", _ctx.tableRequestItem.lockItem.projectIntegrationId.value? 'active' : ''])
                        }, _toDisplayString(item.projectIntegrationIdName), 3),
                        _createElementVNode("td", null, _toDisplayString(item.createName), 1),
                        _createElementVNode("td", null, _toDisplayString(item.createTime), 1),
                        _createElementVNode("td", null, _toDisplayString(item.modifyName), 1),
                        _createElementVNode("td", null, _toDisplayString(item.modifyTime), 1)
                      ], 2))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_app_table_page, {
            class: "card-footer",
            pageItems: _ctx.tablePageItems,
            pageFunction: _ctx.getList
          }, null, 8, ["pageItems", "pageFunction"]),
          (_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                _createVNode(_component_svg_icon, {
                  name: "ali-loading",
                  size: "xl",
                  class: "turn"
                })
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_52, [
      _createVNode(_component_app_alert, { ref: "delModal" }, null, 512),
      _createVNode(_component_app_modal, {
        ref: "qrcodeModal",
        showTitle: false,
        showSubmitButton: false,
        showCloseButton: false
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_53, [
            _createVNode(_component_qrcode_vue, {
              value: _ctx.qrcodeUrl,
              size: 240,
              level: "H",
              "image-settings": _ctx.qrcodeSettings
            }, null, 8, ["value", "image-settings"]),
            _createElementVNode("div", null, _toDisplayString(_ctx.qrcodeTitle), 1)
          ])
        ]),
        _: 1
      }, 512),
      _createVNode(_component_app_select_level, {
        ref: "orgCodeLevel",
        levelType: "select",
        levelApi: _ctx.getOrgApi,
        selectItem: _ctx.tableRequestItem.lockItem.orgCode,
        maxParentId: _ctx.authUser.orgCode,
        selectFunction: _ctx.orgCodeLevelFunction,
        searchFieldList: _ctx.orgCodeLevelSearchField
      }, null, 8, ["levelApi", "selectItem", "maxParentId", "selectFunction", "searchFieldList"]),
      _createVNode(_component_app_select_level, {
        ref: "projectTypeIdLevel",
        levelType: "select",
        levelApi: _ctx.getProjectTypeApi,
        selectItem: _ctx.tableRequestItem.lockItem.projectTypeId,
        selectFunction: _ctx.projectTypeIdLevelFunction,
        searchFieldList: _ctx.projectTypeIdLevelSearchField
      }, null, 8, ["levelApi", "selectItem", "selectFunction", "searchFieldList"]),
      _createVNode(_component_app_select_level, {
        ref: "projectCraftsIdLevel",
        levelType: "select",
        levelApi: _ctx.getProjectCraftsApi,
        selectItem: _ctx.tableRequestItem.lockItem.projectCraftsId,
        selectFunction: _ctx.projectCraftsIdLevelFunction,
        searchFieldList: _ctx.projectCraftsIdLevelSearchField
      }, null, 8, ["levelApi", "selectItem", "selectFunction", "searchFieldList"]),
      _createVNode(_component_app_select_level, {
        ref: "dictionaryLevel",
        levelType: "select",
        levelApi: _ctx.getDictionaryAPI,
        selectItem: this.tableRequestItem.lockItem[this.currentLockCode],
        maxParentId: this.tableRequestItem.lockItem[this.currentLockCode].parent,
        selectFunction: _ctx.dictionaryFunction,
        searchFieldList: _ctx.dictionarySearchField
      }, null, 8, ["levelApi", "selectItem", "maxParentId", "selectFunction", "searchFieldList"]),
      _createVNode(_component_app_modal, {
        ref: "editModal",
        title: _ctx.editModalTitle,
        submitButtonName: _ctx.editModalSubmitButtonName,
        size: "lg",
        submitFunction: _ctx.editModalSubmit,
        submitAfterClose: true
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_54, [
            _createVNode(_component_app_select_from_db, {
              class: "col-lg-6",
              label: "所属组织",
              modelValue: _ctx.editModalItem.orgCode,
              "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => ((_ctx.editModalItem.orgCode) = $event)),
              searchApi: _ctx.orgCodeSelectApi,
              "onUpdate:changeName": _ctx.setOrgCodeName
            }, null, 8, ["modelValue", "searchApi", "onUpdate:changeName"]),
            _createVNode(_component_app_select_from_db, {
              class: "col-lg-6",
              label: "设备类型",
              modelValue: _ctx.editModalItem.projectTypeId,
              "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => ((_ctx.editModalItem.projectTypeId) = $event)),
              searchApi: _ctx.projectTypeIdSelectApi,
              "onUpdate:changeName": _ctx.setProjectTypeIdName,
              "onUpdate:changeValue": _ctx.setProjectCraftsParentId
            }, null, 8, ["modelValue", "searchApi", "onUpdate:changeName", "onUpdate:changeValue"]),
            _createVNode(_component_app_select_from_dictionary, {
              class: "col-lg-4",
              label: "设备年份",
              modelValue: _ctx.editModalItem.projectYeahId,
              "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => ((_ctx.editModalItem.projectYeahId) = $event)),
              code: "prjYeah",
              "onUpdate:changeName": _ctx.setProjectYeahIdName
            }, null, 8, ["modelValue", "onUpdate:changeName"]),
            _createVNode(_component_app_select_from_dictionary, {
              class: "col-lg-4",
              label: "运营模式",
              modelValue: _ctx.editModalItem.projectOptModeId,
              "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => ((_ctx.editModalItem.projectOptModeId) = $event)),
              code: "prjOptMode",
              "onUpdate:changeName": _ctx.setProjectOptModeIdName
            }, null, 8, ["modelValue", "onUpdate:changeName"]),
            _createVNode(_component_app_select_from_db, {
              ref: "projectCraftsIdSelect",
              class: "col-lg-4",
              label: "设备工艺",
              modelValue: _ctx.editModalItem.projectCraftsId,
              "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => ((_ctx.editModalItem.projectCraftsId) = $event)),
              searchApi: _ctx.projectCraftsIdSelectApi,
              "onUpdate:changeName": _ctx.setProjectCraftsIdName
            }, null, 8, ["modelValue", "searchApi", "onUpdate:changeName"]),
            _createVNode(_component_app_input, {
              class: "col-lg-4",
              label: "驾驶舱编号",
              modelValue: _ctx.editModalItem.cockpitCode,
              "onUpdate:modelValue": _cache[24] || (_cache[24] = $event => ((_ctx.editModalItem.cockpitCode) = $event)),
              "onUpdate:changeValue": _ctx.setCockpitCode
            }, null, 8, ["modelValue", "onUpdate:changeValue"]),
            _createVNode(_component_app_input, {
              class: "col-lg-4",
              label: "设备编码(工艺设备编码)",
              modelValue: _ctx.editModalItem.projectCode,
              "onUpdate:modelValue": _cache[25] || (_cache[25] = $event => ((_ctx.editModalItem.projectCode) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_app_input, {
              class: "col-lg-4",
              label: "资产编码(中心资产编码)",
              modelValue: _ctx.editModalItem.assetCode,
              "onUpdate:modelValue": _cache[26] || (_cache[26] = $event => ((_ctx.editModalItem.assetCode) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_app_input, {
              class: "col-lg-8",
              label: "设备名称",
              modelValue: _ctx.editModalItem.projectName,
              "onUpdate:modelValue": _cache[27] || (_cache[27] = $event => ((_ctx.editModalItem.projectName) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_app_select_from_dictionary, {
              class: "col-lg-4",
              label: "设备层数",
              modelValue: _ctx.editModalItem.projectLayerId,
              "onUpdate:modelValue": _cache[28] || (_cache[28] = $event => ((_ctx.editModalItem.projectLayerId) = $event)),
              code: "prjLayerId",
              "onUpdate:changeName": _ctx.setProjectLayerIdName
            }, null, 8, ["modelValue", "onUpdate:changeName"]),
            _createVNode(_component_app_select_from_dictionary, {
              class: "col-lg-4",
              label: "设备来源",
              modelValue: _ctx.editModalItem.projectSourceId,
              "onUpdate:modelValue": _cache[29] || (_cache[29] = $event => ((_ctx.editModalItem.projectSourceId) = $event)),
              code: "projectSourceId"
            }, null, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_55, [
              _hoisted_56,
              _createVNode(_component_el_date_picker, {
                type: "date",
                modelValue: _ctx.editModalItem.acceptanceTime,
                "onUpdate:modelValue": _cache[30] || (_cache[30] = $event => ((_ctx.editModalItem.acceptanceTime) = $event)),
                "value-format": "YYYY-MM-DD",
                style: {"width":"100%","height":"calc(2.25rem + 2px)"}
              }, null, 8, ["modelValue"])
            ]),
            _createVNode(_component_app_switch_number, {
              class: "col-lg-4",
              label: "是否在保",
              modelValue: _ctx.editModalItem.projectWarranty,
              "onUpdate:modelValue": _cache[31] || (_cache[31] = $event => ((_ctx.editModalItem.projectWarranty) = $event)),
              enableName: "在保",
              disabledName: "过保"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_app_textarea, {
              class: "col-lg-12",
              label: "设备说明",
              modelValue: _ctx.editModalItem.projectRemark,
              "onUpdate:modelValue": _cache[32] || (_cache[32] = $event => ((_ctx.editModalItem.projectRemark) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_app_select_from_dictionary, {
              class: "col-lg-4",
              label: "机械",
              modelValue: _ctx.editModalItem.projectMachineId,
              "onUpdate:modelValue": _cache[33] || (_cache[33] = $event => ((_ctx.editModalItem.projectMachineId) = $event)),
              code: "prjMachine"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_app_select_from_dictionary, {
              class: "col-lg-4",
              label: "信息",
              modelValue: _ctx.editModalItem.projectInformationId,
              "onUpdate:modelValue": _cache[34] || (_cache[34] = $event => ((_ctx.editModalItem.projectInformationId) = $event)),
              code: "prjInformation"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_app_select_from_dictionary, {
              class: "col-lg-4",
              label: "集成",
              modelValue: _ctx.editModalItem.projectIntegrationId,
              "onUpdate:modelValue": _cache[35] || (_cache[35] = $event => ((_ctx.editModalItem.projectIntegrationId) = $event)),
              code: "prjIntegration"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_app_switch_number, {
              class: "col-lg-12",
              label: "状态",
              modelValue: _ctx.editModalItem.projectStatus,
              "onUpdate:modelValue": _cache[36] || (_cache[36] = $event => ((_ctx.editModalItem.projectStatus) = $event)),
              enableName: "启用",
              disabledName: "禁用"
            }, null, 8, ["modelValue"])
          ])
        ]),
        _: 1
      }, 8, ["title", "submitButtonName", "submitFunction"])
    ])
  ]))
}